import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './notification.magic.css.js';
import script from './notification.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:[
        _vm.uniqueId || '',
        _vm.variant ? ("notification--" + _vm.variant) : '',
        _vm.isToastNotification && _vm.isNotMessage ? ("notification--toast notification--" + _vm.progressVariant) : '',
        _vm.isAdHocToast ? 'notification--ad-hoc-toast' : ''
    ],attrs:{"data-v-test-id":"notification","part":[
        _vm.$p('notification', [
            _vm.uniqueId || '',
            _vm.variant ? ("notification--" + _vm.variant) : '',
            _vm.isToastNotification && _vm.isNotMessage ? ("notification--toast notification--" + _vm.progressVariant) : '',
            _vm.isAdHocToast ? 'notification--adhoc-toast' : ''
        ])
    ]},on:{"close":_vm.close}},[_c('div',{staticClass:"content",attrs:{"part":"content"}},[(_vm.isNotMessage && !_vm.isToastNotification)?_c('magic-ui-icon',{staticClass:"icon icon--status",class:[_vm.iconVariant],attrs:{"part":_vm.$p('icon icon--status', [_vm.iconVariant]),"name":_vm.iconVariant}}):_vm._e(),_vm._v(" "),_c('div',{ref:"content",staticClass:"text",attrs:{"part":"text","data-v-test-id":"notification-text"}})],1),_vm._v(" "),(_vm.isToastNotification && _vm.isNotMessage && _vm.isAdHocToast)?_c('magic-ui-button',{staticClass:"cta-button",attrs:{"variant":"primary","small":""},on:{"click":_vm.openUrl}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isNotMessage && _vm.isToastNotification && !_vm.isAdHocToast)?_c('div',{class:("icon-toast-container icon-toast-container--" + _vm.variant)},[(_vm.isNotMessage && _vm.isToastNotification)?_c('magic-ui-icon',{staticClass:"icon icon--status",class:[_vm.iconToastVariant],attrs:{"part":_vm.$p('icon icon--status', [_vm.iconToastVariant]),"name":_vm.iconToastVariant}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.shouldShowCloseIcon)?_c('magic-ui-button',{staticClass:"button",attrs:{"icon":"","no-margin":"","no-padding":"","part":"button","variant":"transparent"},on:{"click":_vm.close}},[_c('magic-ui-icon',{staticClass:"icon icon--close",attrs:{"name":"close","part":"icon icon--close","data-v-test-id":"notification-close"}})],1):_vm._e(),_vm._v(" "),(_vm.isToastNotification && _vm.isNotMessage)?_c('div',{class:("progress progress--" + _vm.progressVariant + " progress--" + _vm.variant)}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-b86fbe5e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-b86fbe5e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
